"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryUserSimple = exports.emptyResultProps = void 0;
exports.QueryUser = QueryUser;
const React = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const GraphQLMutationsQueue = __importStar(require("@genesys/graphql-mutations-queue"));
const GraphQLAddRemoveFields = __importStar(require("graphql-add-remove-fields"));
const Elements = __importStar(require("../elements"));
const Contexts = __importStar(require("../contexts"));
const ClientConfig = __importStar(require("../client-config"));
const DebugSettings = __importStar(require("../debug-settings"));
const GlobalActions = __importStar(require("../global-actions"));
const update_from_server_1 = require("./update-from-server");
const result_props_1 = require("./result-props");
const read_from_cache_1 = require("./read-from-cache");
function QueryUser(props) {
    const { modalOnError = false } = props;
    return (React.createElement(ClientConfig.ClientConfigConsumer, null, config => (React.createElement(DebugSettings.DebugSettingsConsumer, null, ({ includeServerLog }) => (React.createElement(Contexts.dispatchContext.Consumer, null, dispatch => (React.createElement(Contexts.UserEntitiesContext.Consumer, null, userEntitiesContext => (React.createElement(QueryUserInternal, Object.assign({}, props, { modalOnError: modalOnError, dispatch: dispatch, userEntitiesContext: userEntitiesContext, includeServerLog: includeServerLog, clientConfigContext: config })))))))))));
}
exports.emptyResultProps = {
    type: "PartialResultProps"
};
class QueryUserInternal extends React.Component {
    constructor(props) {
        super(props);
        this.refetch = () => {
            this.setState({
                result: exports.emptyResultProps
            });
            this.fetchFromServer();
        };
        this.state = {
            entitiesWithNoOptimistic: undefined,
            entitiesWithOptimistic: undefined,
            queryWithRequiredFields: GraphQLAddRemoveFields.addFields(props.query, [
                "__typename"
            ]),
            query: props.query,
            variables: props.variables,
            timestamp: undefined,
            mutationsQueue: undefined,
            result: exports.emptyResultProps
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.query !== nextProps.query) {
            throw new Error("Changing query is not supported");
        }
        // console.log("getDerivedStateFromProps");
        const variablesChanged = !(0, fast_deep_equal_1.default)(nextProps.variables, prevState.variables);
        if (nextProps.userEntitiesContext.entities !==
            prevState.entitiesWithNoOptimistic ||
            variablesChanged ||
            nextProps.mutationsQueue !== prevState.mutationsQueue ||
            nextProps.query !== prevState.query) {
            // console.log("getDerivedStateFromProps variables or entities changed");
            const entitiesWithNoOptimistic = nextProps.userEntitiesContext.entities;
            const entitiesWithOptimistic = nextProps.mutationsQueue &&
                nextProps.mutationsQueue.queuedMutations.length > 0
                ? GraphQLMutationsQueue.optimisticCache(nextProps.mutationsQueue, entitiesWithNoOptimistic)
                : entitiesWithNoOptimistic;
            const variables = variablesChanged
                ? nextProps.variables
                : prevState.variables;
            const { partial, data, stale } = (0, read_from_cache_1.readFromCache)(entitiesWithOptimistic, prevState.queryWithRequiredFields, nextProps.variables, nextProps.clientConfigContext.environment);
            const newState = {
                entitiesWithNoOptimistic,
                entitiesWithOptimistic,
                variables,
                result: (0, result_props_1.createResultProps)(partial, stale, data, entitiesWithNoOptimistic),
                timestamp: nextProps.timestamp
            };
            return newState;
        }
        return {
            timestamp: nextProps.timestamp
        };
    }
    componentDidMount() {
        // console.log("didmount");
        // Didmount cannot be queried more than once per instance
        if ((0, result_props_1.isDirty)(this.state.result)) {
            this.fetchFromServer();
        }
    }
    componentDidUpdate(_, prevState) {
        // Check for force update
        if (prevState.timestamp !== this.state.timestamp) {
            this.refetch();
            return;
        }
        // DidUpdate can be queried multiple times therefore we check if any of our dependencies for request has changed
        if (shouldStartFetchFromServer((0, result_props_1.isDirty)(this.state.result), prevState, this.state)) {
            this.fetchFromServer();
        }
    }
    async fetchFromServer() {
        const { queryWithRequiredFields, variables } = this.state;
        const result = await (0, update_from_server_1.updateFromServer)(queryWithRequiredFields, variables, this.props.includeServerLog, this.props.clientConfigContext.graphqlEndpoint, this.props.clientConfigContext.authorization);
        switch (result.type) {
            case "UpdateFromServerResultSucess": {
                this.props.userEntitiesContext.mergeEntities(result.entities);
                break;
            }
            case "UpdateFromServerResultFailure": {
                this.setState({
                    result: {
                        type: "ErrorResultProps",
                        error: result.error
                    }
                });
                if (this.props.modalOnError) {
                    this.props.dispatch(GlobalActions.error({
                        referenceNo: "",
                        invalidState: true,
                        message: "Data fetching error",
                        exception: result.error
                    }));
                }
                break;
            }
            default: {
                (0, ts_exhaustive_check_1.exhaustiveCheck)(result);
            }
        }
    }
    render() {
        return this.props.children(this.state.result, this.refetch);
    }
}
function shouldStartFetchFromServer(dirty, prevState, state) {
    if (!dirty) {
        return false;
    }
    if (prevState.entitiesWithNoOptimistic !== state.entitiesWithNoOptimistic) {
        return true;
    }
    if (prevState.variables !== state.variables) {
        return true;
    }
    if (prevState.queryWithRequiredFields !== state.queryWithRequiredFields) {
        return true;
    }
    return false;
}
class QueryUserSimple extends React.Component {
    render() {
        // const child = this.props.children;
        const _a = this.props, { children: childFunc } = _a, props = __rest(_a, ["children"]);
        return (React.createElement(QueryUser, Object.assign({}, props, { modalOnError: true }), (resultProps, refetch) => {
            if (resultProps.type === "ErrorResultProps") {
                console.error(resultProps.error);
                return React.createElement("div", null, "Data fetching Error. See console");
            }
            if (resultProps.type === "PartialResultProps" ||
                resultProps.type === "StaleResultProps") {
                return React.createElement(Elements.Loader, null);
            }
            return childFunc(resultProps.data, resultProps.entities, refetch);
        }));
    }
}
exports.QueryUserSimple = QueryUserSimple;
//# sourceMappingURL=query-user.js.map